import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiLoginValidateemailcodeforforgotpasswordMutationRequest,
  PostApiLoginValidateemailcodeforforgotpasswordMutationResponse,
} from "../../../types/PostApiLoginValidateemailcodeforforgotpassword";

export function getPostApiLoginValidateemailcodeforforgotpasswordUrl() {
  return `/api/Login/ValidateEmailCodeForForgotPassword` as const;
}

/**
 * {@link /api/Login/ValidateEmailCodeForForgotPassword}
 */
export async function postApiLoginValidateemailcodeforforgotpassword(
  data?: PostApiLoginValidateemailcodeforforgotpasswordMutationRequest,
  config: Partial<
    RequestConfig<PostApiLoginValidateemailcodeforforgotpasswordMutationRequest>
  > & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiLoginValidateemailcodeforforgotpasswordMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiLoginValidateemailcodeforforgotpasswordMutationRequest
  >({
    method: "POST",
    url: getPostApiLoginValidateemailcodeforforgotpasswordUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
